class CookieDeleter {
	constructor(delay = 5000) {
		this.delay = delay;
		document.addEventListener("DOMContentLoaded", () => this.init());
	}

	init() {
		setTimeout(() => this.deleteCookies(), this.delay);
	}

	deleteCookies() {
		// Find all cookies related to the WP Terms Popup plugin
		const cookies = document.cookie.split(";");
		for (let i = 0; i < cookies.length; i++) {
			let cookie = cookies[i];
			// Trim whitespace
			while (cookie.charAt(0) === " ") {
				cookie = cookie.substring(1);
			}
			// Check if this cookie is from the WP Terms Popup plugin
			if (cookie.indexOf("wptp_terms_") === 0) {
				// Get the cookie name
				const cookieName = cookie.substring(0, cookie.indexOf("="));
				// Delete the cookie by setting its expiry date to the past
				document.cookie =
					cookieName + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";


			}
		}
	}
}

export default CookieDeleter;
